import { useState as c } from "react";
import { UTILITY_ALERT_ICONS_OUTLINE_COLORING_MAP as I, UTILITY_ALERT_ICONS_FILL_BY_VARIANT_MAP as _ } from "./index.es5758.js";
const O = ({
  color: i = "default",
  variant: o = "outline"
}) => {
  const [n, r] = c(!1), e = o === "fill-on-hover" ? n ? "fill" : "outline" : o, t = e === "fill", s = _[e], l = I[i];
  return { strokeColor: l, innerElementFill: t ? "var(--plac-primary-white)" : l, fillColor: t ? l : s, setIsHovered: r };
};
export {
  O as useUtilityAlertIconStyle
};
//# sourceMappingURL=index.es5639.js.map
